document.addEventListener('DOMContentLoaded', function() {
	document.querySelector('select[name="options[Item]"]').addEventListener('change', function(e) {
		e.preventDefault(); 
	});
});

/*offer form*/ 
function openFormFun(){
	let overlay = document.getElementById('overlay');
	let slideForm = document.getElementById('slideForm');
	slideForm.classList.add('active');
	overlay.classList.add('active');
	document.body.style.overflow = 'hidden';
}

function closeFormFun(){
	let overlay = document.getElementById('overlay');
	let slideForm = document.getElementById('slideForm');
	slideForm.classList.remove('active');
	overlay.classList.remove('active');
	document.body.style.overflow = ''; 
}


/*tabs toggle*/
function toggleAccordion(header) {
	const contents = document.querySelectorAll('.tabs_content');
	const headers = document.querySelectorAll('.tabs_head');
	
	const content = header.nextElementSibling;
	const isActive = content.classList.contains('active');
	
	contents.forEach(item => {
		item.classList.remove('active');
	});
	
	headers.forEach(item => {
		item.classList.remove('active');
	});
	
	if (!isActive) {
		content.classList.add('active');
		header.classList.add('active');
	}
}

function scrollProductTabNav(tabItem) {
	var tabsNav = tabItem.closest('.tab-nav');
	if (!tabsNav || window.innerWidth > 1024) return;

	var maxScroll = tabsNav.scrollWidth - tabsNav.clientWidth;
	if (maxScroll <= 0) return;

	var peek = 80;
	var navWidth = tabsNav.clientWidth;
	var btnLeft = tabItem.offsetLeft;
	var btnWidth = tabItem.offsetWidth;
	var targetScroll = btnLeft - (navWidth - btnWidth) / 2;
	var hiddenRight = maxScroll - targetScroll;
	var hiddenLeft = targetScroll;

	if (hiddenRight > peek) {
		targetScroll = Math.min(maxScroll, btnLeft + btnWidth - navWidth + peek);
	} else if (hiddenLeft > peek) {
		targetScroll = Math.max(0, btnLeft - peek);
	}

	tabsNav.scrollTo({
		left: Math.max(0, Math.min(maxScroll, targetScroll)),
		behavior: 'smooth'
	});
}

function initProductTabNavScroll() {
	if (window.innerWidth > 1024) return;

	document.querySelectorAll('.template-product .product-tabNav-desktop .tab-nav').forEach(function(tabsNav) {
		var activeTab = tabsNav.querySelector('.tab-nav-item.is-active') || tabsNav.querySelector('.tab-nav-item');
		if (activeTab) scrollProductTabNav(activeTab);
	});
}

function getProductTabStickyTop() {
	var value = getComputedStyle(document.documentElement).getPropertyValue('--product-sticky-header-height').trim();
	return parseFloat(value) || 0;
}

function getProductTabsComponent(tabsNavigation) {
	if (!tabsNavigation) return null;

	var tabsId = tabsNavigation.getAttribute('for');
	if (tabsId) {
		var byId = document.getElementById(tabsId);
		if (byId) return byId;
	}

	var sibling = tabsNavigation.nextElementSibling;
	if (sibling && sibling.tagName === 'TABS-COMPONENT') {
		return sibling;
	}

	return document.querySelector('.template-product .product-tabs-component');
}

function scrollToProductTabSection(tabsNavigation) {
	if (!tabsNavigation || window.innerWidth > 1024) return;

	requestAnimationFrame(function () {
		syncProductStickyHeaderHeight();

		var stickyTop = getProductTabStickyTop();
		var tabNavHeight = tabsNavigation.offsetHeight;
		var scrollY = window.pageYOffset || document.documentElement.scrollTop;
		var tabsComponent = getProductTabsComponent(tabsNavigation);
		var contentDocTop;

		if (tabsComponent) {
			contentDocTop = tabsComponent.getBoundingClientRect().top + scrollY;
		} else {
			contentDocTop = tabsNavigation.getBoundingClientRect().top + scrollY + tabNavHeight;
		}

		var target = contentDocTop - stickyTop - tabNavHeight;

		window.scrollTo({
			top: Math.max(0, target),
			behavior: 'smooth'
		});
	});
}

function syncProductStickyHeaderHeight() {
	if (window.innerWidth > 1024) {
		document.documentElement.style.setProperty('--product-sticky-header-height', '0px');
		return;
	}

	var sectionHeader = document.querySelector('.section-header');
	if (!sectionHeader) {
		document.documentElement.style.setProperty('--product-sticky-header-height', '0px');
		return;
	}

	var height = 0;
	var headerHidden = sectionHeader.classList.contains('section-header-hidden');
	var headerSticky =
		sectionHeader.classList.contains('section-header-sticky') ||
		sectionHeader.classList.contains('section-header-sticky-always');

	if (!headerHidden && headerSticky) {
		height = sectionHeader.offsetHeight;
	}

	document.documentElement.style.setProperty('--product-sticky-header-height', height + 'px');
}

function initProductTabNavHeaderOffset() {
	if (window.innerWidth > 1024) return;

	syncProductStickyHeaderHeight();

	var sectionHeader = document.querySelector('.section-header');
	if (!sectionHeader || sectionHeader.dataset.productTabOffsetObserved === 'true') return;

	sectionHeader.dataset.productTabOffsetObserved = 'true';
	var observer = new MutationObserver(syncProductStickyHeaderHeight);
	observer.observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });

	if (!window.__productTabHeaderOffsetScrollBound) {
		window.__productTabHeaderOffsetScrollBound = true;
		window.addEventListener('scroll', syncProductStickyHeaderHeight, { passive: true });
	}
}

document.addEventListener('DOMContentLoaded', function () {
	initProductTabNavHeaderOffset();
	initProductTabNavScroll();

	document.querySelectorAll('.template-product tabs-navigation.product-tabNav-desktop').forEach(function (tabsNavigation) {
		if (typeof tabsNavigation.setActiveTab === 'function') {
			var setActiveTab = tabsNavigation.setActiveTab.bind(tabsNavigation);
			tabsNavigation.setActiveTab = function (nav) {
				var previous = tabsNavigation.querySelector('.tab-nav-item.is-active');
				var isTabChange = previous && nav && previous !== nav;

				setActiveTab(nav);

				if (nav && nav.classList && nav.classList.contains('tab-nav-item')) {
					scrollProductTabNav(nav);
				}

				if (isTabChange) {
					scrollToProductTabSection(tabsNavigation);
				}
			};
		}
	});
});

window.addEventListener('resize', function () {
	initProductTabNavHeaderOffset();
	initProductTabNavScroll();
});

/* Product FAQ: convert H4 + following content into accordion items */
function initCsProductFaq() {
	document.querySelectorAll('[data-cs-faq-source]').forEach(function (source) {
		if (source.getAttribute('data-converted') === 'true') return;

		var headings = Array.prototype.slice.call(source.querySelectorAll('h4'));
		if (!headings.length) {
			source.setAttribute('data-converted', 'true');
			return;
		}

		var accordion = document.createElement('div');
		accordion.className = 'cs-product-faq__accordion';

		headings.forEach(function (heading) {
			var details = document.createElement('details');
			details.className = 'cs-faq-item';

			var summary = document.createElement('summary');
			summary.className = 'cs-faq-item__question';

			var questionText = document.createElement('span');
			questionText.className = 'cs-faq-item__question-text';
			questionText.textContent = heading.textContent.trim();

			var icon = document.createElement('span');
			icon.className = 'cs-faq-item__icon';
			icon.setAttribute('aria-hidden', 'true');

			summary.appendChild(questionText);
			summary.appendChild(icon);

			var answer = document.createElement('div');
			answer.className = 'cs-faq-item__answer rte';

			var node = heading.nextSibling;
			while (node && !(node.nodeType === 1 && node.tagName === 'H4')) {
				var next = node.nextSibling;
				answer.appendChild(node);
				node = next;
			}

			details.appendChild(summary);
			details.appendChild(answer);
			accordion.appendChild(details);
		});

		source.innerHTML = '';
		source.appendChild(accordion);
		source.setAttribute('data-converted', 'true');
	});

	initCsProductFaqDefaultOpen();
}

function initCsProductFaqDefaultOpen() {
	var isDesktop = window.matchMedia('(min-width: 750px)').matches;

	document.querySelectorAll('.cs-product-faq').forEach(function (faq) {
		var items = faq.querySelectorAll('.cs-faq-item');
		items.forEach(function (item, index) {
			if (isDesktop && index === 0) {
				item.setAttribute('open', '');
			} else if (!isDesktop) {
				item.removeAttribute('open');
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', initCsProductFaq);
window.addEventListener('resize', initCsProductFaqDefaultOpen);